export const CURRENCY_CODES = [
	{ code: 'USD', symbol: '$' }, // United States Dollar
	{ code: 'AUD', symbol: '$' }, // Australian Dollar
	{ code: 'EUR', symbol: '€' }, // Euro
	{ code: 'GBP', symbol: '£' }, // British Pound
	{ code: 'JPY', symbol: '¥' }, // Japanese Yen
	{ code: 'SGD', symbol: '$' }, // Singapore Dollar
	{ code: 'CAD', symbol: '$' }, // Canadian Dollar
	{ code: 'AED', symbol: 'د.إ' }, // United Arab Emirates Dirham
	{ code: 'AFN', symbol: '؋' }, // Afghan Afghani
	{ code: 'ALL', symbol: 'Lek' }, // Albanian Lek
	{ code: 'AMD', symbol: '֏' }, // Armenian Dram
	{ code: 'AOA', symbol: 'Kz' }, // Angolan Kwanza
	{ code: 'ARS', symbol: '$' }, // Argentine Peso
	{ code: 'AWG', symbol: 'ƒ' }, // Aruban Florin
	{ code: 'AZN', symbol: '₼' }, // Azerbaijani Manat
	{ code: 'BAM', symbol: 'KM' }, // Bosnia and Herzegovina Convertible Mark
	{ code: 'BHD', symbol: '.د.ب' }, // Bahraini Dinar
	{ code: 'BIF', symbol: 'FBu' }, // Burundian Franc
	{ code: 'BND', symbol: '$' }, // Brunei Dollar
	{ code: 'BRL', symbol: 'R$' }, // Brazilian Real
	{ code: 'BWP', symbol: 'P' }, // Botswana Pula
	{ code: 'BYN', symbol: 'Br' }, // Belarusian Ruble
	{ code: 'CHF', symbol: 'CHF' }, // Swiss Franc
	{ code: 'CLP', symbol: '$' }, // Chilean Peso
	{ code: 'CNY', symbol: '¥' }, // Chinese Yuan
	{ code: 'COP', symbol: '$' }, // Colombian Peso
	{ code: 'CZK', symbol: 'Kč' }, // Czech Koruna
	{ code: 'DKK', symbol: 'kr' }, // Danish Krone
	{ code: 'DJF', symbol: 'Fdj' }, // Djiboutian Franc
	{ code: 'FJD', symbol: '$' }, // Fijian Dollar
	{ code: 'GEL', symbol: '₾' }, // Georgian Lari
	{ code: 'GHS', symbol: '₵' }, // Ghanaian Cedi
	{ code: 'GMD', symbol: 'D' }, // Gambian Dalasi
	{ code: 'HUF', symbol: 'Ft' }, // Hungarian Forint
	{ code: 'HRK', symbol: 'kn' }, // Croatian Kuna
	{ code: 'IDR', symbol: 'Rp' }, // Indonesian Rupiah
	{ code: 'ILS', symbol: '₪' }, // Israeli New Shekel
	{ code: 'INR', symbol: '₹' }, // Indian Rupee
	{ code: 'ISK', symbol: 'kr' }, // Icelandic Króna
	{ code: 'JMD', symbol: '$' }, // Jamaican Dollar
	{ code: 'JOD', symbol: 'د.ا' }, // Jordanian Dinar
	{ code: 'KMF', symbol: 'CF' }, // Comorian Franc
	{ code: 'KGS', symbol: 'с' }, // Kyrgyzstani Som
	{ code: 'KRW', symbol: '₩' }, // South Korean Won
	{ code: 'KWD', symbol: 'د.ك' }, // Kuwaiti Dinar
	{ code: 'KZT', symbol: '₸' }, // Kazakhstani Tenge
	{ code: 'LAK', symbol: '₭' }, // Laotian Kip
	{ code: 'MDL', symbol: 'L' }, // Moldovan Leu
	{ code: 'MMK', symbol: 'K' }, // Myanmar Kyat
	{ code: 'MNT', symbol: '₮' }, // Mongolian Tögrög
	{ code: 'MRU', symbol: 'UM' }, // Mauritanian Ouguiya
	{ code: 'MXN', symbol: '$' }, // Mexican Peso
	{ code: 'MYR', symbol: 'RM' }, // Malaysian Ringgit
	{ code: 'NGN', symbol: '₦' }, // Nigerian Naira
	{ code: 'NOK', symbol: 'kr' }, // Norwegian Krone
	{ code: 'NZD', symbol: '$' }, // New Zealand Dollar
	{ code: 'OMR', symbol: 'ر.ع.' }, // Omani Rial
	{ code: 'PEN', symbol: 'S/' }, // Peruvian Sol
	{ code: 'PHP', symbol: '₱' }, // Philippine Peso
	{ code: 'PKR', symbol: '₨' }, // Pakistani Rupee
	{ code: 'PLN', symbol: 'zł' }, // Polish Zloty
	{ code: 'QAR', symbol: 'ر.ق' }, // Qatari Rial
	{ code: 'RON', symbol: 'lei' }, // Romanian Leu
	{ code: 'RUB', symbol: '₽' }, // Russian Ruble
	{ code: 'RWF', symbol: 'FRw' }, // Rwandan Franc
	{ code: 'SEK', symbol: 'kr' }, // Swedish Krona
	{ code: 'SLL', symbol: 'Le' }, // Sierra Leonean Leone
	{ code: 'SOS', symbol: 'Sh' }, // Somali Shilling
	{ code: 'SRD', symbol: '$' }, // Surinamese Dollar
	{ code: 'SZL', symbol: 'L' }, // Swazi Lilangeni
	{ code: 'THB', symbol: '฿' }, // Thai Baht
	{ code: 'TRY', symbol: '₺' }, // Turkish Lira
	{ code: 'TTD', symbol: '$' }, // Trinidad and Tobago Dollar
	{ code: 'TZS', symbol: 'TSh' }, // Tanzanian Shilling
	{ code: 'UAH', symbol: '₴' }, // Ukrainian Hryvnia
	{ code: 'UGX', symbol: 'USh' }, // Ugandan Shilling
	{ code: 'VND', symbol: '₫' }, // Vietnamese Dong
	{ code: 'XAF', symbol: 'FCFA' }, // Central African CFA Franc
	{ code: 'XCD', symbol: '$' }, // East Caribbean Dollar
	{ code: 'XOF', symbol: 'CFA' }, // West African CFA Franc
	{ code: 'XPF', symbol: '₣' }, // CFP Franc
	{ code: 'YER', symbol: '﷼' }, // Yemeni Rial
	{ code: 'ZAR', symbol: 'R' }, // South African Rand
	{ code: 'ZMW', symbol: 'ZK' }, // Zambian Kwacha
	{ code: 'ZWL', symbol: '$' }, // Zimbabwean Dollar
] as const;

export type CurrencyCode = (typeof CURRENCY_CODES)[number]['code'];
